var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"nav-header"},[_c('div',{staticClass:"empty"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"close"},[_c('img',{attrs:{"src":"/imgs/close.png","alt":"close"},on:{"click":_vm.back}})])]),_vm._v(" "),_c('Nuxt')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/imgs/logo.png","alt":"logo"}})])
}]

export { render, staticRenderFns }